// Existing bukietowa.pl 2023 web stream 4449099481, property 350725061.
export const GOOGLE_ANALYTICS_CONFIG = {
  tagId: 'G-YKNM2G70M9',
  hosts: ['bukietowa.pl', 'www.bukietowa.pl'],
} as const;
